<ngx-loading
[show]="loading"
[config]="loaderConfig"
></ngx-loading>

<router-outlet></router-outlet>
<app-footer></app-footer>